module.exports = __webpack_public_path__ + "img/full3-min.9f44782f.png";